<template>
  <transition
    mode="in-out"
    appear
    leave-active-class="select-options-wrapper-fi--leaving"
    @after-leave="emit('close')"
  >
    <div
      v-if="notClosing"
      class="select-options-wrapper-fi"
    >
      <div
        v-if="!isSM"
        class="select-options-wrapper-fi__header"
      >
        <div
          class="select-options-wrapper-fi__close"
          @click="close"
        >
          <icon-fi icon="arrow-left" />
          {{ name }}
        </div>
        <div
          v-if="hasSelection && !required"
          class="select-options-wrapper-fi__deselect"
          @click="emit('clear-selection')"
        >
          {{ dict.get('facets.Clear-Text-Mobile') }}
          <icon-fi icon="close" />
        </div>
      </div>
      <div class="select-options-wrapper-fi__item-wrapper">
        <slot />
      </div>
      <slot name="footer" />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import IconFi from '@/components/atoms/icon-fi/IconFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useDict } from '@/composables/fischerPlugin';

interface Props {
  name: string;
  hasSelection?: boolean;
  required?: boolean;
}

interface Emits {
  (e: 'close'): void;
  (e: 'clear-selection'): void;
}

defineProps<Props>();

const emit = defineEmits<Emits>();

const { isSM } = useBreakpoints();

const notClosing = ref(true);

const close = async () => {
  if (isSM.value) {
    emit('close');
  } else {
    notClosing.value = false;
  }
};

defineExpose({
  close,
});
const dict = useDict();
</script>

<style scoped src="./select-options-wrapper-fi" />
